import { FilterDivider } from '../../../FilterDivider'
import { PageActions } from '../../../Page'
import { Pagination } from '../../../Pagination'
import { Skeleton } from '../../../Skeleton'
import {
  getTableResetSortingButton,
  Table,
  TableConfigModal,
  TableControlBar,
  TableControlButtons,
  TableViewRegimeControl,
} from '../../../Table'
import { APPLICANTS_TABLE_SKELETON_ROWS } from '../RentalPortalApplicants.constants'
import { getIsApplicantsTableEmpty } from '../RentalPortalApplicants.utils'
import { RentalPortalApplicantsBoard } from '../RentalPortalApplicantsBoard'
import { RentalPortalApplicantsEmptyState } from '../RentalPortalApplicantsEmptyState'
import { RentalPortalApplicantsLoadError } from '../RentalPortalApplicantsLoadError'
import { RentalPortalApplicantsTableRow } from '../RentalPortalApplicantsTableRow'

import * as styles from './RentalPortalApplicantsTableLayout.module.css'

function RentalPortalApplicantsTableLayout({
  EmptyState = RentalPortalApplicantsEmptyState,
  ErrorState = RentalPortalApplicantsLoadError,
  hasBodyError,
  tablePage,
}) {
  const {
    applicants,
    boardColumns,
    columns,
    entity,
    handleApply,
    handleChangeViewType,
    handleClearFilters,
    handleClickApplicant,
    handleConfigOpen,
    handleMouseDownApplicant,
    handleReload,
    handleReloadBoard,
    handleResetOrdering,
    handleSetColumns,
    handleSetOrdering,
    handleSetPagination,
    handleSetSize,
    handleShowStageInTable,
    hasActiveFilters,
    hasBoardError,
    isBoardLoading,
    isBoardRegime,
    isConfigOpen,
    isLoading,
    isRefetching,
    listViewType,
    ordering,
    pageScrollWrapperRef,
    pagination,
    refreshButtonProps,
    requiredColumns,
    setConfigOpen,
  } = tablePage

  return (
    <>
      <TableControlBar>
        <PageActions className={styles.pageActions}>
          <TableControlButtons
            keepChangeViewTypeButtonOnNarrowScreen
            ChangeViewTypeButton={TableViewRegimeControl}
            DensityButton={null}
            ResetSortingButton={getTableResetSortingButton(ordering)}
            changeViewTypeButtonProps={{
              hasBoard: true,
              hasSplit: false,
              listViewType,
              onChange: handleChangeViewType,
            }}
            configButtonProps={{
              disabled: isBoardRegime,
              onClick: handleConfigOpen,
            }}
            isSkeleton={isLoading}
            refreshButtonProps={refreshButtonProps}
            resetSortingProps={{ onClick: handleResetOrdering }}
          />
          <FilterDivider />
          {isLoading ? (
            <Skeleton className={styles.paginationSkeleton} />
          ) : (
            <Pagination
              responsive
              disabled={isBoardRegime}
              value={pagination}
              onChange={handleSetPagination}
              onChangeSize={handleSetSize}
            />
          )}
        </PageActions>
      </TableControlBar>
      {hasBodyError ? (
        <ErrorState isRefetching={isRefetching} onRetry={handleReload} />
      ) : isBoardRegime ? (
        <RentalPortalApplicantsBoard
          ErrorState={ErrorState}
          columns={boardColumns}
          hasError={hasBoardError}
          isLoading={isBoardLoading}
          onClickCard={handleClickApplicant}
          onMouseDownCard={handleMouseDownApplicant}
          onRetry={handleReloadBoard}
          onShowMore={handleShowStageInTable}
        />
      ) : getIsApplicantsTableEmpty({ applicants, isLoading }) ? (
        <EmptyState
          hasActiveFilters={hasActiveFilters}
          onClearFilters={handleClearFilters}
        />
      ) : (
        <Table
          TableRow={RentalPortalApplicantsTableRow}
          columns={columns}
          containerRef={pageScrollWrapperRef}
          headerRowProps={{
            ordering,
            onApply: handleApply,
            onSetColumns: handleSetColumns,
            onSetOrdering: handleSetOrdering,
          }}
          isLoading={isLoading}
          items={applicants}
          rowProps={{
            hideCheckbox: true,
            onClick: handleClickApplicant,
            onMouseDown: handleMouseDownApplicant,
          }}
          skeletonRows={APPLICANTS_TABLE_SKELETON_ROWS}
        />
      )}
      {isConfigOpen ? (
        <TableConfigModal
          columns={columns}
          entity={entity}
          requiredColumns={requiredColumns}
          setColumns={handleSetColumns}
          setConfigOpen={setConfigOpen}
          onApply={handleApply}
        />
      ) : null}
    </>
  )
}

export default RentalPortalApplicantsTableLayout
